export default "__VITE_ASSET__5eeeee29__"